<template>
    <div>
        <p>about</p>
    </div>
</template>

<script>
export default {
    name : "about",
    data () {
        return {

        }
    }
}
</script>
<style>

</style>

